const translation = {
  allTags: '所有标签',
  searchTags: '搜索标签',
  tags: {
    agent: 'Agent',
    search: '搜索',
    image: '图片',
    videos: '视频',
    weather: '天气',
    finance: '金融',
    design: '设计',
    travel: '旅行',
    social: '社交',
    news: '新闻',
    medical: '医疗',
    productivity: '生产力',
    education: '教育',
    business: '商业',
    entertainment: '娱乐',
    utilities: '工具',
    other: '其他',
  },
}

export default translation
